<input
	type="text"
	[class.visually-hidden]="options?.invisible"
	ngbDatepicker
	#dp="ngbDatepicker"
	[displayMonths]="options?.displayMonths || 1"
	[autoClose]="options?.autoClose || 'outside'"
	[navigation]="options?.navigation || 'arrows'"
	[minDate]="minDateForPicker || defaultMin"
	[maxDate]="maxDateForPicker || defaultMax"
	[startDate]="fromDate || minDateForPicker || today"
	(dateSelect)="onDateSelection($event)"
	outsideDays="hidden"
	tabindex="-1"
/>
